import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// FIX: this was importing and rendering LandingPage directly, bypassing
// App.js entirely — which meant no BrowserRouter, no <Route> matching, no
// AuthProvider, no ProtectedRoute. Every URL (typed directly or via nav)
// caused a real full-page navigation, and this file rendered the same
// unconditional LandingPage regardless of path — matching exactly the
// "URL bar shows /dashboard but landing page renders underneath" symptom.
// Likely a leftover from testing the landing page redesign in isolation
// that didn't get reverted before deploying.
import App from './App';

// 1. Grab the element first
const rootElement = document.getElementById('root');

// 2. Add a failsafe check
if (!rootElement) {
  throw new Error(
    "Failed to find the root element. Make sure there is a <div id='root'></div> in your public/index.html"
  );
}

// 3. Mount the application
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);